import { RocketLaunch } from "@mui/icons-material";
import { Box } from "@mui/material";
import { ExerciseInterface } from "../../../../interfaces/examInterfaces";
import { useSelector } from "react-redux";
import { RootState } from "../../../..";
import {
  BoxNumber,
  ExerciseContainer,
  ExerciseImage,
  ExerciseNumber,
  PointsContainerPdf,
  PointsPdf,
  Rocket,
} from "./LegacyStyles";

export const LegacyPDFExercise = ({
  exercise,
  imageUrl,
  solutionImageUrl,
  zoomFactor,
}: {
  exercise: ExerciseInterface;
  imageUrl: string;
  solutionImageUrl: string;
  zoomFactor: number;
}) => {
  const showSolutions = useSelector((state: RootState) => state.examBuilder.main.showSolutions);

  return (
    <>
      <Box>
        <ExerciseContainer zoomfactor={zoomFactor}>
          <BoxNumber zoomfactor={zoomFactor}>
            <ExerciseNumber zoomfactor={zoomFactor}>{exercise.index + 1})</ExerciseNumber>
          </BoxNumber>

          <ExerciseImage zoomfactor={zoomFactor}>
            <img src={showSolutions ? solutionImageUrl : imageUrl} alt="" />
          </ExerciseImage>

          {exercise.level === 3 && (
            <Rocket zoomfactor={zoomFactor}>
              <RocketLaunch />
            </Rocket>
          )}
        </ExerciseContainer>
        <PointsContainerPdf zoomfactor={zoomFactor}>
          <PointsPdf zoomfactor={zoomFactor}>/ {exercise.points}</PointsPdf>
        </PointsContainerPdf>
      </Box>
    </>
  );
};

export default LegacyPDFExercise;
